import { render, staticRenderFns } from "./vTextArea.vue?vue&type=template&id=49f8f7d5"
import script from "./vTextArea.vue?vue&type=script&lang=js"
export * from "./vTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports